/**
 * Dismisses the static splash that the standalone index.html paints before any JS runs.
 *
 * The splash covers the whole viewport so the startup chain (entry bundle, styles,
 * locale catalogs, initial route loaders) resolves behind visible feedback instead of a
 * blank page. It must go away exactly once the router has settled its first navigation —
 * removing it earlier reintroduces the blank gap, and index.html carries a hard timeout
 * as the failsafe against a bootstrap that never settles.
 *
 * In web-component (DCC) deployments the host page is not ours, the element does not
 * exist, and this is a no-op.
 */
export function removeAppSplash(): void {
  document.getElementById('e3d-splash')?.remove();
}
